import * as React from "react"
import PropTypes from "prop-types"
//
import { Wrapper } from "./style"
import { css } from "styled-components"

export function Marquee({ children, ...props }) {
  return (
    <Wrapper {...props} data-testid="component-content-marquee">
      {children}
    </Wrapper>
  )
}

Marquee.propTypes = {
  image: PropTypes.string.isRequired,
  gradient: PropTypes.string,
  children: PropTypes.node.isRequired,
  style: PropTypes.object,
  className: PropTypes.string,
}

Marquee.defaultProps = {
  gradient:
    "linear-gradient(to bottom, rgba(255,255,255,0) 0%,rgba(255,255,255,0) 100%)",
  className: css`
    min-height: 310px;
    padding: 45px 0;
  `,
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/Marquee/index.js